import React from "react";
import * as BosIdentityServices from "data/BosWebServices/BosIdentityServices";
import LoginHeader from "./LoginHeader";
import { getTranslation as translate } from "logic/LocaleManager";

import { LOGINTYPE_REGISTER_GLOBALUSER } from "pages/Login/LoginPage";

// DevExtreme components
import TextBox from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator, { RequiredRule } from 'devextreme-react/validator';
import Button from 'devextreme-react/button';

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as bosUserActions from "../../redux/actions/bosUserActions";

function RegisterGlobalUser(props) {
  const { actionSuccessfull, actionError, setIsLoading, isLoading, } = props;
  const registerFailedText = translate("registerGlobaluser.failed", "Register failed!");

  async function register(args) {
    if (!args.validationGroup.validate().isValid) return;
    await registerInternal();
    args.validationGroup.reset();
  }

  async function registerInternal(usr) {
    try {
      setIsLoading(true);
      let result = await BosIdentityServices.fetchRegisterGlobalUser();
      if (!result || !result.token) throw new Error("NO TOKEN RECEIVED");
      props.bosUserActions.setBosUser({
        newDisplayName: usr,
        newAuthToken: result.token,
        newPersistIn: "local"
      });
      actionSuccessfull(LOGINTYPE_REGISTER_GLOBALUSER, result.startUri, null, result.enableLaunchpad);
    } catch (error) {
      props.bosUserActions.clearBosUser();
      actionError(registerFailedText + " (" + error + ")");
      setIsLoading(false);
    }
  }

  return (
    <ValidationGroup>
      <LoginHeader title={translate("registerGlobaluser.title", "Register")} description={translate("registerGlobaluser.description", "Upload your BOS Identity Card")} />
      <div className={'dx-field'}>
        <TextBox
          placeholder={translate("registerGlobaluser.textBoxFileLabel", "Choose file...")}
          disabled={isLoading}
          width={'100%'}
        >
          <Validator>
            <RequiredRule message={translate("registerGlobaluser.textBoxFileError", "File is required")} />
          </Validator>
        </TextBox>
      </div>
      <div className={'dx-field'}>
        <Button
          type={'default'}
          text={translate("registerGlobaluser.action", "Register")}
          onClick={register}
          disabled={isLoading}
          width={'100%'}
        />
      </div>
    </ValidationGroup>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    bosUserActions: bindActionCreators(bosUserActions, dispatch)
  };
}

export default connect(
  null,
  mapDispatchToProps
)(RegisterGlobalUser);
